import React, {Component} from 'react'
import * as config from '../Configuration/Config.js'
import * as pbi from 'powerbi-client';
import * as models from 'powerbi-models';
import {isMobile} from 'react-device-detect';
import UserProfile from '../Configuration/UserProfile';
// import qs from 'query-string';

class VisualizationNew extends Component {
    componentDidMount() {
        const did = this.props.match.params.did;
        const gid = this.props.match.params.gid;
        const uri = config.getUriPath('visualizations/embedTokenCreate?dataset_id=' + did + '&group_id='+ gid);

        this.profile = new UserProfile();        
        var varCustomerId = this.profile.CustomerId();
        console.log('EDIT varCustomerId: ' + varCustomerId);
        
        //customerinfo
        var that = this;        
        const uricst = config.getUriPath('customers/' + varCustomerId)
        var varCustomerCustomWorkspace = ''; 
        var userDefaultPage = this.profile.DefaultPage();
        fetch(uricst, {
            method: 'get',
            headers: config.ApiHeaders()
           }).then(function(response) {
            if (response.status >= 400) {
              throw new Error("Bad response from server");
            }
            return response.json();
          })
          .then(function(data) {           
            console.log(data);
            console.log('data.customer_custom_workspace_id ' + data.customer_custom_workspace_id);
            if (data.customer_custom_workspace_id.toLowerCase() !== gid.toLowerCase())
            {
              console.log('redirect');
              window.location.replace(userDefaultPage);
            }
        });

        const mobileLayout = models.LayoutType.MobilePortrait;
        const desktopLayout = models.LayoutType.Custom;
        var thisLayout = desktopLayout;
        if (isMobile) {
            thisLayout = mobileLayout;
        }
        var v_viewMode = models.ViewMode.Edit;
        var v_Permissions = models.Permissions.All;

        fetch(uri, {
            method: 'get',
            headers: config.ApiHeaders()
           }).then(function(response) {
            if (response.status >= 400) {
              throw new Error("Bad response from server");
            }

            if (response.status >= 204) {
                return null;
            }

            return response.json();
          })
          .then(function(data) {
            if (data == null) {
                return;
            }
            
            
            const embedUrl = "https://app.powerbi.com/reportEmbed?groupId=" + gid;
                          
              var embedCreateConfiguration = {
                tokenType: models.TokenType.Embed,
                accessToken:  data.token,
                embedUrl: embedUrl,
                datasetId: did,
               };

               let powerbi = new pbi.service.Service(pbi.factories.hpmFactory, pbi.factories.wpmpFactory, pbi.factories.routerFactory);
               var reportContainer = document.getElementById('rptContainer');
               
               // Create report
               var report = powerbi.createReport(reportContainer, embedCreateConfiguration);
               
               report.on("saved", function (event) {
                 console.log(event.detail);
                 if (event.detail.saveAs) {
                    console.log('redirect to new report');
                    var varNewtRID = event.detail.reportObjectId;
                    var newURL = '/visualizations/edit/{rid}/{gid}'.replace('{rid}',varNewtRID).replace('{gid}',gid);
                    console.log(newURL);                    
                    window.location.replace(newURL);
                 }
               });
               report.on("error", function (event) {
                console.log(event.detail);                
               });   
          });   
    }

    render() {
        return <div>
                    <div className="center-div">
                        <div className="rptContainer" id="rptContainer">&nbsp;</div>
                    </div>
                </div>
    }
}

export default VisualizationNew


// WEBPACK FOOTER //
// ./src/Components/Visualizations/VisualizationNew.js